import React, {useState, useMemo} from 'react'
import {appointmentReports} from "../../services/serviceReports";
import {Card, Col, Row, Table, Space, Statistic } from "antd";
import Filter from "../filterWrapper/Filter";
import AppointmentReportFilters from './AppointmentReportFilters';
import {SearchOutlined} from "@ant-design/icons";
import { getAppointmentsInRange } from '../../services/serviceAppointment';
import AppointmentTags from '../appointment/AppointmentTags';
import userDateFormatter from '../../services/formatters/userDateFormatter';
import AppointmentDetails from '../appointment/AppointmentDetails';

const timeStampToDate = (endDate, startDate) => {
    const timeStampDiff = endDate - startDate
    const days = (timeStampDiff / 1000) / 60 / 60 / 24
    const weeks = Math.floor(days/7);
    const extraDays = days % 7;
    const total = ( weeks * 5 ) + extraDays
    return total;
};

const AppointmentReports = () => {
    const [tableData, setTableData] = useState({});
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [openFilter, setOpenFilter] = useState(false);
    const [modalData, setModalData] = useState([]);

    const dateDiffs = useMemo(() => timeStampToDate(endDate, startDate), [startDate, endDate]);

    const onEmployeeClick = (body) => {
        getAppointmentsInRange(body)
            .then(({data}) => {
                if(data) {
                    const structured = data.map((item, idx) => {
                        return {
                            key: idx,
                            appointmentId: item.id,
                            brandName: item.brand?.name || '',
                            customerName: item.customer?.name || '',
                            planningDate: item.planningDate,
                            status: item.status || '',
                            title: item.title || '',
                            resultText: item.resultText || ''
                        }
                    })
                    setModalData(structured);
                }
            })
    };

    const employeeColumns = [
        {title: 'Müşteri', dataIndex: 'customerName'},
        {title: 'Marka', dataIndex: 'brandName'},
        {title: 'Tarih', dataIndex: 'planningDate', render: (t) => userDateFormatter(t)},
        {title: 'Durumu', dataIndex: 'status', render: (t, r) => <AppointmentTags status={t} report={r.resultText} />},
        {title: 'Sonuç', render: (t, r) => <AppointmentDetails appointmentId={r.appointmentId} />},
    ];

    const toggleFilterDisplay = () => setOpenFilter(!openFilter);
    const handleClear = () => setTableData([]);
    const getAverageAppointment = (record) => `% ${new Intl.NumberFormat().format(100 * (record / dateDiffs))}`;


    const handleReport = (filterData) => {
        let startDate = null, endDate = null;
        if(filterData.dateRange && filterData.dateRange.length) {
            startDate = filterData.dateRange[0]._d;
            endDate = filterData.dateRange[1]._d;
            setStartDate(startDate);
            setEndDate(endDate);
        }

        const reqObj = filterData;
        delete reqObj.dateRange;
        reqObj.startDate = startDate ?? null;
        reqObj.endDate = endDate ?? null;
        reqObj.status = filterData.status ?? null;
        reqObj.brandId = filterData.brandId ??  null;
        reqObj.customerId = filterData.customerId ?? null;
        reqObj.employee = filterData.employee ?? null;
        
        appointmentReports(reqObj)
            .then(({data}) => setTableData(data))
            .then(() => onEmployeeClick(reqObj))

        return new Promise((res, rej) => {
            res(true);
            rej(false);
        })
    }

    const getAvgTotal = () => {
        const data = tableData.appointmentEmployeeDTOS[0];
        return `% ${new Intl.NumberFormat().format( ((data.positive) * 100) / data.total)}`
    };

    return (
        <React.Fragment>
            <Card
                title={'Randevu Raporları'}
            >
                <Space direction={"vertical"} size={'large'} style={{width: '100%'}}>
                    <Row justify={"start"}>
                        <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined/></div>
                    </Row>
                    {
                        tableData?.appointmentEmployeeDTOS?.length ?
                        <Row justify={'space-between'}>
                            <Col span={3}>
                              <Statistic title={'Olumlu'} value={tableData.appointmentEmployeeDTOS[0].positive}/>
                            </Col>
                            <Col span={3}>
                              <Statistic title={'Olumsuz'} value={tableData.appointmentEmployeeDTOS[0].negative}/>
                            </Col>
                            <Col span={3}>
                              <Statistic title={'Bekliyor'} value={tableData.appointmentEmployeeDTOS[0].waiting}/>
                            </Col>
                            <Col span={3}>
                               <Statistic title={'Toplam'} value={tableData.appointmentEmployeeDTOS[0].total}/>
                            </Col>
                            <Col span={3}>
                                <Statistic title={'Ortalama'} value={getAverageAppointment(tableData.appointmentEmployeeDTOS[0].total)} />
                            </Col>
                            <Col span={3}>
                               <Statistic title={'Başarılı/Toplam'} value={getAvgTotal()}/>
                            </Col>
                        </Row>
                     :null 
                    }
                    <Table 
                        style={{marginTop: '16px'}}
                        rowKey={'key'}
                        columns={employeeColumns} 
                        dataSource={modalData} 
                        scroll={{x: 'max-content'}} 
                    />
                </Space>
            </Card>
            <Filter
                showDrawer={openFilter}
                relatedComponent={'Randevu'}
                closer={toggleFilterDisplay}
                handler={handleReport}
                resetHandler={handleClear}
            >
                <AppointmentReportFilters />
            </Filter>
        </React.Fragment>
    )
}
export default AppointmentReports